<template>
	<div>
		<p>
			Author contributions:
			<a
				style="color: #52699a;"
				href="https://credit.niso.org/"
				target="_blank"
				title="Contributor Roles Taxonomy(CRediT)"
				>CRediT</a
			>
		</p>
		<div v-if="$tera.project.conAuthors && outputData.length > 0">
			<!--New Output Start-->
			<p v-if="(element = findElement('Conceptualization'))">
				Conceptualization:
				<template v-if="Object.keys(element).length != 0">
					{{ joinArrayWithAnd(element.authors.map(el => nameToInitials(el))) }}
				</template>
				<template v-else>None</template>
			</p>
			<p v-if="(element = findElement('Data curation'))">
				Data curation:
				<template v-if="Object.keys(element).length != 0">
					{{ joinArrayWithAnd(element.authors.map(el => nameToInitials(el))) }}
				</template>
				<template v-else>None</template>
			</p>
			<p v-if="(element = findElement('Formal analysis'))">
				Formal analysis:
				<template v-if="Object.keys(element).length != 0">
					{{ joinArrayWithAnd(element.authors.map(el => nameToInitials(el))) }}
				</template>
				<template v-else>None</template>
			</p>
			<p v-if="(element = findElement('Funding acquisition'))">
				Funding acquisition:
				<template v-if="Object.keys(element).length != 0">
					{{ joinArrayWithAnd(element.authors.map(el => nameToInitials(el))) }}
				</template>
				<template v-else>None</template>
			</p>
			<p v-if="(element = findElement('Investigation'))">
				Investigation:
				<template v-if="Object.keys(element).length != 0">
					{{ joinArrayWithAnd(element.authors.map(el => nameToInitials(el))) }}
				</template>
				<template v-else>None</template>
			</p>
			<p v-if="(element = findElement('Methodology'))">
				Methodology:
				<template v-if="Object.keys(element).length != 0">
					{{ joinArrayWithAnd(element.authors.map(el => nameToInitials(el))) }}
				</template>
				<template v-else>None</template>
			</p>
			<p v-if="(element = findElement('Project administration'))">
				Project administration:
				<template v-if="Object.keys(element).length != 0">
					{{ joinArrayWithAnd(element.authors.map(el => nameToInitials(el))) }}
				</template>
				<template v-else>None</template>
			</p>
			<p v-if="(element = findElement('Resources'))">
				Resources:
				<template v-if="Object.keys(element).length != 0">
					{{ joinArrayWithAnd(element.authors.map(el => nameToInitials(el))) }}
				</template>
				<template v-else>None</template>
			</p>
			<p v-if="(element = findElement('Software'))">
				Software:
				<template v-if="Object.keys(element).length != 0">
					{{ joinArrayWithAnd(element.authors.map(el => nameToInitials(el))) }}
				</template>
				<template v-else>None</template>
			</p>
			<p v-if="(element = findElement('Supervision'))">
				Supervision:
				<template v-if="Object.keys(element).length != 0">
					{{ joinArrayWithAnd(element.authors.map(el => nameToInitials(el))) }}
				</template>
				<template v-else>None</template>
			</p>
			<p v-if="(element = findElement('Validation'))">
				Validation:
				<template v-if="Object.keys(element).length != 0">
					{{ joinArrayWithAnd(element.authors.map(el => nameToInitials(el))) }}
				</template>
				<template v-else>None</template>
			</p>
			<p v-if="(element = findElement('Writing - original draft'))">
				Writing - original draft:
				<template v-if="Object.keys(element).length != 0">
					{{ joinArrayWithAnd(element.authors.map(el => nameToInitials(el))) }}
				</template>
				<template v-else>None</template>
			</p>
			<p v-if="(element = findElement('Writing - review & editing'))">
				Writing - review & editing:
				<template v-if="Object.keys(element).length != 0">
					{{ joinArrayWithAnd(element.authors.map(el => nameToInitials(el))) }}
				</template>
				<template v-else>None</template>
			</p>
			<!--New Output End-->
		</div>
	</div>
</template>
<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputContributions",
	mixins: [OutputMixin],
	/*props: {
		//data: Object,
		contributionOptions: Array
	},*/
	data() {
		return {
			extractUnion: false,
			draftUnion: false,
			contributionOptions: [
				{ label: "Conceptualization" },
				{ label: "Data curation" },
				{ label: "Formal analysis" },
				{ label: "Funding acquisition" },
				{ label: "Investigation" },
				{ label: "Methodology" },
				{ label: "Project administration" },
				{ label: "Resources" },
				{ label: "Software" },
				{ label: "Supervision" },
				{ label: "Validation" },
				{ label: "Visualization" },
				{ label: "Writing - original draft" },
				{ label: "Writing - review & editing" }
			]
		};
	},
	computed: {
		outputData() {
			let da = [];
			if (this.$tera.project.conAuthors.length > 0) {
				this.$tera.project.conAuthors.forEach(el => {
					if (el.author != "" && el.selectedOpt.length > 0) {
						da = this.dataBuild(da, el);
					}
				});
			}
			return da;
		},
		newlyAddedContributions() {
			let allLabels = [].concat(
				...this.$tera.project.conAuthors.map(item =>
					item.selectedOpt.map(opt => opt.label)
				)
			);
			let newlyAdded = allLabels.filter(
				labelA =>
					!this.contributionOptions.some(itemB => itemB.label === labelA)
				//!this.checkOptions(labelA)
			);
			return newlyAdded;
		}
	},
	methods: {
		/**
		 *
		 * @param {option : String, authors : Array} output
		 * @param {author : String, selectedOpt :Array} element
		 */
		dataBuild(output, element) {
			element.selectedOpt.forEach(opt => {
				let ifContains = false;
				if (output.length > 0) {
					output.forEach(op => {
						if (op.option == opt.label) {
							ifContains = true;
							op.authors.push(element.author);
						}
					});
				}
				if (ifContains == false) {
					output.push({ option: opt.label, authors: [element.author] });
				}
			});
			return output;
		},
		findElement(option) {
			let element = {};
			this.outputData.forEach(el => {
				if (el.option == option) {
					element = el;
				}
			});
			return element;
		}
	}
};
</script>
<style></style>
